import React from 'react';

import { QuickFilterButton, Typography } from '@hpi-sox/hpstellar-core/visId';

import './css/search-page-filter-controls.less';

export default function FilterControls({ facets, toggleFacet }) {
    const activeFilters = facets?.reduce((all, f) => {
        f?.Values?.forEach(v => {
            if (v.Selected) {
                let label = v?.Label;
                if (f.Name === 'CUSTOMER RATINGS') {
                    //TODO: clean up with regex
                    label = v?.Label?.replaceAll('&#9733;', '')
                        .replaceAll('&#9734;', '')
                        .replaceAll('& Up', '')
                        .trim()
                        .replace('5', 'Ratings: 5/5')
                        .replace('4', 'Ratings: 4/5')
                        .replace('3', 'Ratings: 3/5')
                        .replace('2', 'Ratings: 2/5')
                        .replace('1', 'Ratings: 1/5');
                }
                all.push(
                    <QuickFilterButton
                        isActive
                        children={label}
                        onClick={e => {
                            toggleFacet(f?.Field, v?.Value)();
                        }}
                    />,
                );
            }

            if (f.Name === 'PRICE RANGE' && (v?.RangeStart !== v?.RangeMin || v?.RangeEnd !== v?.RangeMax)) {
                all.push(
                    <QuickFilterButton
                        isActive
                        children={`$${v?.RangeStart} - $${v?.RangeEnd}`}
                        onClick={e => {
                            toggleFacet(f?.Field, `${v?.RangeStart},${v?.RangeEnd}`)();
                        }}
                    />,
                );
            }
        });
        return all;
    }, []);

    if (activeFilters?.length < 1) return null;

    return (
        <div className="searchControls">
            <Typography>Active filters</Typography>
            <div className="controls">{activeFilters}</div>
        </div>
    );
}
